import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserQuizResults } from '../../types';
import { resolveApiCall } from '../../services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { QuizApi } from '../../services/end-points';
import { ThunkConfig } from '../configure-store';

export const getUserQuizResults = createAsyncThunk<
    Paginated<UserQuizResults>,
    { id: string; onError: (data: any) => any },
    ThunkConfig
>('user-quiz-results/current', async (payload, thunkAPI) => {
    const { getState } = thunkAPI;
    const { userQuizResult } = getState();
    const { id, onError } = payload;

    return resolveApiCall(thunkAPI, userQuizResult, async () => (await QuizApi.get(id)).data, onError);
});
